await import('/app/data/stock-mirror/web/node_modules/.pnpm/@umijs+bundler-webpack@4.6.9_@types+webpack@5.28.5_type-fest@1.4.0_typescript@5.9.3_webpack@5.104.1/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/app/data/stock-mirror/web/src/.umi/umi.ts');
export default 1;